/**
 * Guess queue and billing source from a catalog service (#44).
 * The rate card has no queue or billable_kind column of its own — category
 * (monthly / project / usage) is the one fact that maps onto how minutes
 * are billed, and the code's keywords map onto which queue works it.
 */

import {
  TASK_QUEUES,
  type BillableKind,
  type ServiceCategory,
  type TaskQueue,
} from '@fareast/shared'

export function queueForService(code: string): TaskQueue | null {
  const trimmed = code.trim().toLowerCase()
  if (trimmed === '') return null
  if (trimmed.startsWith('seo_') || trimmed.includes('seo')) return 'seo'
  if (trimmed.startsWith('odoo_') || trimmed.includes('odoo')) return 'odoo'
  if (
    trimmed.includes('video') ||
    trimmed.includes('content') ||
    trimmed.includes('social') ||
    trimmed.includes('reel') ||
    trimmed.includes('carousel') ||
    trimmed.includes('article')
  ) {
    return 'content'
  }
  if (trimmed.includes('report')) return 'reports'
  if ((TASK_QUEUES as readonly string[]).includes(trimmed)) return trimmed as TaskQueue
  return 'delivery'
}

/**
 * What minutes against this service most likely draw on (#44).
 * monthly → their package; project → a work order; usage → the studio absorbs it
 * (widget metering is billed elsewhere, not as task time).
 */
export function billableKindForServiceCategory(category: ServiceCategory): BillableKind {
  switch (category) {
    case 'monthly':
      return 'retainer'
    case 'project':
      return 'project'
    case 'usage':
      return 'account'
  }
}
